import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "6",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#777",
      "fill-rule": "evenodd",
      d: "M.195.195c.26-.26.683-.26.943 0l4.029 4.029L9.195.195a.667.667 0 0 1 .943.943l-4.5 4.5a.667.667 0 0 1-.943 0l-4.5-4.5a.667.667 0 0 1 0-.943",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }